import { render, staticRenderFns } from "./GeneralDialogSeletorPredicaoBaixas.vue?vue&type=template&id=b2f54b4a&"
import script from "./GeneralDialogSeletorPredicaoBaixas.vue?vue&type=script&lang=js&"
export * from "./GeneralDialogSeletorPredicaoBaixas.vue?vue&type=script&lang=js&"
import style0 from "./GeneralDialogSeletorPredicaoBaixas.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCard,VCardTitle,VCol,VDataTable,VDialog,VIcon,VRow,VTextField,VTooltip})
